/**
 * User roles as returned by the `/who-am-i` endpoint (`IWhoAmI.role`, a plain
 * `string` in `src/interfaces/interfaces.ts`). Kept as a `const` object (not
 * a TS `enum`) so it is trivially comparable against that plain string type.
 */
export const ROLES = {
  GUEST: 'guest',
  OPERATOR: 'operator',
  CHIEF_OPERATOR: 'chief_operator',
  ADMIN: 'admin',
  DEACTIVATED: 'deactivated',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

interface IWhoAmIRole {
  role: string;
}

export function hasRole(
  whoAmI: IWhoAmIRole | null | undefined,
  ...roles: string[]
): boolean {
  if (!whoAmI) {
    return false;
  }
  return roles.includes(whoAmI.role);
}

export function isAdmin(whoAmI?: IWhoAmIRole | null): boolean {
  return hasRole(whoAmI, ROLES.ADMIN);
}
